export default "__VITE_ASSET__293d0df1__"